import { StaffPaymentStatusEnum } from '../../types/enums/affected-staff/staff-payment-status.enum'
import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { MissionToStaffSalaryFilter } from '../../types/models/mission-tracking/mission-tracking'

export const transformMissionToStaffSalaryFiltersToUrl = (
  filters?: MissionToStaffSalaryFilter
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.periodIds && filters.periodIds.length > 0)
    searchParams.set('periodIds', filters.periodIds.join(','))

  if (filters.qualifications && filters.qualifications.length > 0)
    searchParams.set('qualifications', filters.qualifications.join(','))

  if (filters.positions && filters.positions.length > 0)
    searchParams.set('positions', filters.positions.join(','))

  if (filters.paymentStatuses && filters.paymentStatuses.length > 0)
    searchParams.set('paymentStatuses', filters.paymentStatuses.join(','))

  if (filters.missionBeforeDate) searchParams.set('missionBeforeDate', filters.missionBeforeDate)
  if (filters.missionAfterDate) searchParams.set('missionAfterDate', filters.missionAfterDate)

  if (filters.contractBeforeDate)
    searchParams.set('contractBeforeDate', filters.contractBeforeDate)
  if (filters.contractAfterDate) searchParams.set('contractAfterDate', filters.contractAfterDate)

  if (filters.affectedAfterDate) searchParams.set('affectedAfterDate', filters.affectedAfterDate)
  if (filters.affectedBeforeDate)
    searchParams.set('affectedBeforeDate', filters.affectedBeforeDate)

  if (filters.missionTypeIds && filters.missionTypeIds.length > 0)
    searchParams.set('missionTypeIds', filters.missionTypeIds.join(','))

  return searchParams.toString()
}

export const transformUrlToMissionToStaffSalaryFilters = (
  searchParams: URLSearchParams
): MissionToStaffSalaryFilter => {
  const filters: MissionToStaffSalaryFilter = {}

  const periodIds = searchParams.get('periodIds')
  if (periodIds) filters.periodIds = periodIds.split(',').map(Number)

  const qualifications = searchParams.get('qualifications')
  if (qualifications)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]

  const positions = searchParams.get('positions')
  if (positions) filters.positions = positions.split(',') as StaffPositionEnum[]

  const paymentStatuses = searchParams.get('paymentStatuses')
  if (paymentStatuses)
    filters.paymentStatuses = paymentStatuses.split(',') as StaffPaymentStatusEnum[]

  const missionBeforeDate = searchParams.get('missionBeforeDate')
  if (missionBeforeDate) filters.missionBeforeDate = missionBeforeDate

  const missionAfterDate = searchParams.get('missionAfterDate')
  if (missionAfterDate) filters.missionAfterDate = missionAfterDate

  const contractBeforeDate = searchParams.get('contractBeforeDate')
  if (contractBeforeDate) filters.contractBeforeDate = contractBeforeDate

  const contractAfterDate = searchParams.get('contractAfterDate')
  if (contractAfterDate) filters.contractAfterDate = contractAfterDate

  const affectedAfterDate = searchParams.get('affectedAfterDate')
  if (affectedAfterDate) filters.affectedAfterDate = affectedAfterDate

  const affectedBeforeDate = searchParams.get('affectedBeforeDate')
  if (affectedBeforeDate) filters.affectedBeforeDate = affectedBeforeDate

  const missionTypeIds = searchParams.get('missionTypeIds')
  if (missionTypeIds) filters.missionTypeIds = missionTypeIds.split(',').map(Number)

  return filters
}
